
import "../Foundation/stylable/spacing.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../BaseModalLayout/BaseModalLayout.st.css.js";

import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_214_3_CustomModalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_214_3_CustomModalLayout__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-50":"--wds-space-50","wds-custom-modal-footer-padding-vertical":"--wds-custom-modal-footer-padding-vertical","wds-custom-modal-footer-padding-horizontal":"--wds-custom-modal-footer-padding-horizontal","wds-custom-modal-header-padding-vertical":"--wds-custom-modal-header-padding-vertical","wds-custom-modal-header-padding-right":"--wds-custom-modal-header-padding-right","wds-custom-modal-header-padding-left":"--wds-custom-modal-header-padding-left","wds-custom-modal-header-subtitle-font-size":"--wds-custom-modal-header-subtitle-font-size","wds-custom-modal-header-subtitle-font-line-height":"--wds-custom-modal-header-subtitle-font-line-height","wds-custom-modal-content-padding-horizontal":"--wds-custom-modal-content-padding-horizontal","wds-custom-modal-content-padding-vertical":"--wds-custom-modal-content-padding-vertical","wds-custom-modal-border-radius":"--wds-custom-modal-border-radius","wds-close-button-standard-filled-size-large":"--wds-close-button-standard-filled-size-large","wds-font-size-body-medium":"--wds-font-size-body-medium","wds-font-line-height-body-medium":"--wds-font-line-height-body-medium","wsr-text-line-height-medium":"--wsr-text-line-height-medium","wsr-text-font-size-medium":"--wsr-text-font-size-medium"}; 




